// extracted by mini-css-extract-plugin
export default {"contactTablePadding":"app__PolicyCommonContacts__contactTablePadding","tablecell":"app__PolicyCommonContacts__tablecell"};